// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-international-phone-country-selector {
  position: relative;
}
.react-international-phone-country-selector-button {
  display: flex;
  height: var(--react-international-phone-height, 36px);
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid
    var(
      --react-international-phone-country-selector-border-color,
      var(--react-international-phone-border-color, gainsboro)
    );
  margin: 0;
  appearance: button;
  -webkit-appearance: button;
  background-color: var(
    --react-international-phone-country-selector-background-color,
    var(--react-international-phone-background-color, white)
  );
  cursor: pointer;
  text-transform: none;
  user-select: none;
}
.react-international-phone-country-selector-button:hover {
  background-color: var(
    --react-international-phone-country-selector-background-color-hover,
    whitesmoke
  );
}
.react-international-phone-country-selector-button--hide-dropdown {
  cursor: auto;
}
.react-international-phone-country-selector-button--hide-dropdown:hover {
  background-color: transparent;
}
.react-international-phone-country-selector-button__button-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
.react-international-phone-country-selector-button__flag-emoji {
  margin: 0 4px;
}
.react-international-phone-country-selector-button__flag-emoji--disabled {
  opacity: 0.75;
}
.react-international-phone-country-selector-button__dropdown-arrow {
  border-top: var(--react-international-phone-country-selector-arrow-size, 4px)
    solid var(--react-international-phone-country-selector-arrow-color, #777);
  border-right: var(
      --react-international-phone-country-selector-arrow-size,
      4px
    )
    solid transparent;
  border-left: var(--react-international-phone-country-selector-arrow-size, 4px)
    solid transparent;
  margin-right: 4px;
  transition: all 0.1s ease-out;
}
.react-international-phone-country-selector-button__dropdown-arrow--active {
  transform: rotateX(180deg);
}
.react-international-phone-country-selector-button__dropdown-arrow--disabled {
  border-top-color: var(
    --react-international-phone-disabled-country-selector-arrow-color,
    #999
  );
}
.react-international-phone-country-selector-button--disabled {
  background-color: var(
    --react-international-phone-disabled-country-selector-background-color,
    var(--react-international-phone-disabled-background-color, whitesmoke)
  );
  cursor: auto;
}
.react-international-phone-country-selector-button--disabled:hover {
  background-color: var(
    --react-international-phone-disabled-country-selector-background-color,
    var(--react-international-phone-disabled-background-color, whitesmoke)
  );
}
.react-international-phone-flag-emoji {
  width: var(--react-international-phone-flag-width, 24px);
  height: var(--react-international-phone-flag-height, 24px);
  box-sizing: border-box;
}
.react-international-phone-country-selector-dropdown {
  position: absolute;
  z-index: 1;
  top: var(--react-international-phone-dropdown-top, 44px);
  left: var(--react-international-phone-dropdown-left, 0);
  display: flex;
  width: 300px;
  max-height: 200px;
  flex-direction: column;
  padding: 4px 0;
  margin: 0;
  background-color: var(
    --react-international-phone-dropdown-item-background-color,
    var(--react-international-phone-background-color, white)
  );
  box-shadow: var(
    --react-international-phone-dropdown-shadow,
    2px 2px 16px rgba(0, 0, 0, 0.25)
  );
  color: var(
    --react-international-phone-dropdown-item-text-color,
    var(--react-international-phone-text-color, #222)
  );
  list-style: none;
  overflow-y: scroll;
}
.react-international-phone-country-selector-dropdown__preferred-list-divider {
  height: 1px;
  border: none;
  margin: var(
    --react-international-phone-dropdown-preferred-list-divider-margin,
    0
  );
  background: var(
    --react-international-phone-dropdown-preferred-list-divider-color,
    var(--react-international-phone-border-color, gainsboro)
  );
}
.react-international-phone-country-selector-dropdown__list-item {
  display: flex;
  min-height: var(--react-international-phone-dropdown-item-height, 28px);
  box-sizing: border-box;
  align-items: center;
  padding: 2px 8px;
}
.react-international-phone-country-selector-dropdown__list-item-flag-emoji {
  margin-right: 8px;
}
.react-international-phone-country-selector-dropdown__list-item-country-name {
  overflow: hidden;
  margin-right: 8px;
  font-size: var(--react-international-phone-dropdown-item-font-size, 14px);
  text-overflow: ellipsis;
  white-space: nowrap;
}
.react-international-phone-country-selector-dropdown__list-item-dial-code {
  color: var(--react-international-phone-dropdown-item-dial-code-color, black);
  font-size: var(--react-international-phone-dropdown-item-font-size, 14px);
}
.react-international-phone-country-selector-dropdown__list-item:hover {
  background-color: var(--primary);
  color: white;
  cursor: pointer;
}

.react-international-phone-country-selector-dropdown__list-item:hover
  .react-international-phone-country-selector-dropdown__list-item-dial-code {
  color: white;
}

.react-international-phone-country-selector-dropdown__list-item--selected,
.react-international-phone-country-selector-dropdown__list-item--focused {
  background-color: var(--primary);
  color: white;
}
.react-international-phone-country-selector-dropdown__list-item--selected
  .react-international-phone-country-selector-dropdown__list-item-dial-code,
.react-international-phone-country-selector-dropdown__list-item--focused
  .react-international-phone-country-selector-dropdown__list-item-dial-code {
  color: var(
    --react-international-phone-selected-dropdown-item-dial-code-color,
    var(--react-international-phone-dropdown-item-dial-code-color, white)
  );
}

.react-international-phone-country-selector-dropdown__list-item--focused {
  background-color: var(--primary);
}
.react-international-phone-dial-code-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  border: 1px solid
    var(
      --react-international-phone-dial-code-preview-border-color,
      var(--react-international-phone-border-color, gainsboro)
    );
  margin-right: -1px;
  background-color: var(
    --react-international-phone-dial-code-preview-background-color,
    var(--react-international-phone-background-color, white)
  );
  color: var(
    --react-international-phone-dial-code-preview-text-color,
    var(--react-international-phone-text-color, #222)
  );
  font-size: var(
    --react-international-phone-dial-code-preview-font-size,
    var(--react-international-phone-font-size, 13px)
  );
}
.react-international-phone-dial-code-preview--disabled {
  background-color: var(
    --react-international-phone-dial-code-preview-disabled-background-color,
    var(--react-international-phone-disabled-background-color, whitesmoke)
  );
  color: var(
    --react-international-phone-dial-code-preview-disabled-text-color,
    var(--react-international-phone-disabled-text-color, #666)
  );
}
.react-international-phone-input-container {
  display: flex;
}
.react-international-phone-input-container
  .react-international-phone-country-selector-button {
  border-radius: var(--react-international-phone-border-radius, 4px);
  margin-right: -1px;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}
.react-international-phone-input-container .react-international-phone-input {
  overflow: visible;
  height: var(--react-international-phone-height, 36px);
  box-sizing: border-box;
  padding: 0 8px;
  border: 1px solid var(--react-international-phone-border-color, gainsboro);
  border-radius: var(--react-international-phone-border-radius, 4px);
  margin: 0;
  background-color: var(--react-international-phone-background-color, white);
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  color: var(--react-international-phone-text-color, #222);
  font-family: inherit;
  font-size: var(--react-international-phone-font-size, 13px);
}
.react-international-phone-input-container
  .react-international-phone-input:focus {
  outline: none;
}
.react-international-phone-input-container
  .react-international-phone-input--disabled {
  background-color: var(
    --react-international-phone-disabled-background-color,
    whitesmoke
  );
  color: var(--react-international-phone-disabled-text-color, #666);
}
`, "",{"version":3,"sources":["webpack://./src/components/Reusable/PhoneNumberField/style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,qDAAqD;EACrD,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV;;;;KAIG;EACH,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B;;;GAGC;EACD,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE;;;GAGC;AACH;AACA;EACE,YAAY;AACd;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE;6EAC2E;EAC3E;;;;qBAImB;EACnB;qBACmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE;;;GAGC;AACH;AACA;EACE;;;GAGC;EACD,YAAY;AACd;AACA;EACE;;;GAGC;AACH;AACA;EACE,wDAAwD;EACxD,0DAA0D;EAC1D,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,wDAAwD;EACxD,uDAAuD;EACvD,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,SAAS;EACT;;;GAGC;EACD;;;GAGC;EACD;;;GAGC;EACD,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ;;;GAGC;EACD;;;GAGC;AACH;AACA;EACE,aAAa;EACb,uEAAuE;EACvE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yEAAyE;EACzE,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,4EAA4E;EAC5E,yEAAyE;AAC3E;AACA;EACE,gCAAgC;EAChC,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,gCAAgC;EAChC,YAAY;AACd;AACA;;;;EAIE;;;GAGC;AACH;;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd;;;;KAIG;EACH,kBAAkB;EAClB;;;GAGC;EACD;;;GAGC;EACD;;;GAGC;AACH;AACA;EACE;;;GAGC;EACD;;;GAGC;AACH;AACA;EACE,aAAa;AACf;AACA;;EAEE,kEAAkE;EAClE,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,qDAAqD;EACrD,sBAAsB;EACtB,cAAc;EACd,0EAA0E;EAC1E,kEAAkE;EAClE,SAAS;EACT,0EAA0E;EAC1E,4BAA4B;EAC5B,yBAAyB;EACzB,wDAAwD;EACxD,oBAAoB;EACpB,2DAA2D;AAC7D;AACA;;EAEE,aAAa;AACf;AACA;;EAEE;;;GAGC;EACD,iEAAiE;AACnE","sourcesContent":[".react-international-phone-country-selector {\n  position: relative;\n}\n.react-international-phone-country-selector-button {\n  display: flex;\n  height: var(--react-international-phone-height, 36px);\n  box-sizing: border-box;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 1px solid\n    var(\n      --react-international-phone-country-selector-border-color,\n      var(--react-international-phone-border-color, gainsboro)\n    );\n  margin: 0;\n  appearance: button;\n  -webkit-appearance: button;\n  background-color: var(\n    --react-international-phone-country-selector-background-color,\n    var(--react-international-phone-background-color, white)\n  );\n  cursor: pointer;\n  text-transform: none;\n  user-select: none;\n}\n.react-international-phone-country-selector-button:hover {\n  background-color: var(\n    --react-international-phone-country-selector-background-color-hover,\n    whitesmoke\n  );\n}\n.react-international-phone-country-selector-button--hide-dropdown {\n  cursor: auto;\n}\n.react-international-phone-country-selector-button--hide-dropdown:hover {\n  background-color: transparent;\n}\n.react-international-phone-country-selector-button__button-content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.react-international-phone-country-selector-button__flag-emoji {\n  margin: 0 4px;\n}\n.react-international-phone-country-selector-button__flag-emoji--disabled {\n  opacity: 0.75;\n}\n.react-international-phone-country-selector-button__dropdown-arrow {\n  border-top: var(--react-international-phone-country-selector-arrow-size, 4px)\n    solid var(--react-international-phone-country-selector-arrow-color, #777);\n  border-right: var(\n      --react-international-phone-country-selector-arrow-size,\n      4px\n    )\n    solid transparent;\n  border-left: var(--react-international-phone-country-selector-arrow-size, 4px)\n    solid transparent;\n  margin-right: 4px;\n  transition: all 0.1s ease-out;\n}\n.react-international-phone-country-selector-button__dropdown-arrow--active {\n  transform: rotateX(180deg);\n}\n.react-international-phone-country-selector-button__dropdown-arrow--disabled {\n  border-top-color: var(\n    --react-international-phone-disabled-country-selector-arrow-color,\n    #999\n  );\n}\n.react-international-phone-country-selector-button--disabled {\n  background-color: var(\n    --react-international-phone-disabled-country-selector-background-color,\n    var(--react-international-phone-disabled-background-color, whitesmoke)\n  );\n  cursor: auto;\n}\n.react-international-phone-country-selector-button--disabled:hover {\n  background-color: var(\n    --react-international-phone-disabled-country-selector-background-color,\n    var(--react-international-phone-disabled-background-color, whitesmoke)\n  );\n}\n.react-international-phone-flag-emoji {\n  width: var(--react-international-phone-flag-width, 24px);\n  height: var(--react-international-phone-flag-height, 24px);\n  box-sizing: border-box;\n}\n.react-international-phone-country-selector-dropdown {\n  position: absolute;\n  z-index: 1;\n  top: var(--react-international-phone-dropdown-top, 44px);\n  left: var(--react-international-phone-dropdown-left, 0);\n  display: flex;\n  width: 300px;\n  max-height: 200px;\n  flex-direction: column;\n  padding: 4px 0;\n  margin: 0;\n  background-color: var(\n    --react-international-phone-dropdown-item-background-color,\n    var(--react-international-phone-background-color, white)\n  );\n  box-shadow: var(\n    --react-international-phone-dropdown-shadow,\n    2px 2px 16px rgba(0, 0, 0, 0.25)\n  );\n  color: var(\n    --react-international-phone-dropdown-item-text-color,\n    var(--react-international-phone-text-color, #222)\n  );\n  list-style: none;\n  overflow-y: scroll;\n}\n.react-international-phone-country-selector-dropdown__preferred-list-divider {\n  height: 1px;\n  border: none;\n  margin: var(\n    --react-international-phone-dropdown-preferred-list-divider-margin,\n    0\n  );\n  background: var(\n    --react-international-phone-dropdown-preferred-list-divider-color,\n    var(--react-international-phone-border-color, gainsboro)\n  );\n}\n.react-international-phone-country-selector-dropdown__list-item {\n  display: flex;\n  min-height: var(--react-international-phone-dropdown-item-height, 28px);\n  box-sizing: border-box;\n  align-items: center;\n  padding: 2px 8px;\n}\n.react-international-phone-country-selector-dropdown__list-item-flag-emoji {\n  margin-right: 8px;\n}\n.react-international-phone-country-selector-dropdown__list-item-country-name {\n  overflow: hidden;\n  margin-right: 8px;\n  font-size: var(--react-international-phone-dropdown-item-font-size, 14px);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.react-international-phone-country-selector-dropdown__list-item-dial-code {\n  color: var(--react-international-phone-dropdown-item-dial-code-color, black);\n  font-size: var(--react-international-phone-dropdown-item-font-size, 14px);\n}\n.react-international-phone-country-selector-dropdown__list-item:hover {\n  background-color: var(--primary);\n  color: white;\n  cursor: pointer;\n}\n\n.react-international-phone-country-selector-dropdown__list-item:hover\n  .react-international-phone-country-selector-dropdown__list-item-dial-code {\n  color: white;\n}\n\n.react-international-phone-country-selector-dropdown__list-item--selected,\n.react-international-phone-country-selector-dropdown__list-item--focused {\n  background-color: var(--primary);\n  color: white;\n}\n.react-international-phone-country-selector-dropdown__list-item--selected\n  .react-international-phone-country-selector-dropdown__list-item-dial-code,\n.react-international-phone-country-selector-dropdown__list-item--focused\n  .react-international-phone-country-selector-dropdown__list-item-dial-code {\n  color: var(\n    --react-international-phone-selected-dropdown-item-dial-code-color,\n    var(--react-international-phone-dropdown-item-dial-code-color, white)\n  );\n}\n\n.react-international-phone-country-selector-dropdown__list-item--focused {\n  background-color: var(--primary);\n}\n.react-international-phone-dial-code-preview {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 8px;\n  border: 1px solid\n    var(\n      --react-international-phone-dial-code-preview-border-color,\n      var(--react-international-phone-border-color, gainsboro)\n    );\n  margin-right: -1px;\n  background-color: var(\n    --react-international-phone-dial-code-preview-background-color,\n    var(--react-international-phone-background-color, white)\n  );\n  color: var(\n    --react-international-phone-dial-code-preview-text-color,\n    var(--react-international-phone-text-color, #222)\n  );\n  font-size: var(\n    --react-international-phone-dial-code-preview-font-size,\n    var(--react-international-phone-font-size, 13px)\n  );\n}\n.react-international-phone-dial-code-preview--disabled {\n  background-color: var(\n    --react-international-phone-dial-code-preview-disabled-background-color,\n    var(--react-international-phone-disabled-background-color, whitesmoke)\n  );\n  color: var(\n    --react-international-phone-dial-code-preview-disabled-text-color,\n    var(--react-international-phone-disabled-text-color, #666)\n  );\n}\n.react-international-phone-input-container {\n  display: flex;\n}\n.react-international-phone-input-container\n  .react-international-phone-country-selector-button {\n  border-radius: var(--react-international-phone-border-radius, 4px);\n  margin-right: -1px;\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n}\n.react-international-phone-input-container .react-international-phone-input {\n  overflow: visible;\n  height: var(--react-international-phone-height, 36px);\n  box-sizing: border-box;\n  padding: 0 8px;\n  border: 1px solid var(--react-international-phone-border-color, gainsboro);\n  border-radius: var(--react-international-phone-border-radius, 4px);\n  margin: 0;\n  background-color: var(--react-international-phone-background-color, white);\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n  color: var(--react-international-phone-text-color, #222);\n  font-family: inherit;\n  font-size: var(--react-international-phone-font-size, 13px);\n}\n.react-international-phone-input-container\n  .react-international-phone-input:focus {\n  outline: none;\n}\n.react-international-phone-input-container\n  .react-international-phone-input--disabled {\n  background-color: var(\n    --react-international-phone-disabled-background-color,\n    whitesmoke\n  );\n  color: var(--react-international-phone-disabled-text-color, #666);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
